import { Box, Grid, Link, Typography } from '@mui/material';
import Uploader from 'lib/designSystem/Uploader';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface UploadSectionProps {
  onFileChange: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void | Promise<void>;
  uploadedFileName: string | null;
  onDownloadTemplate: () => void;
}

const UploadSection: React.FC<UploadSectionProps> = ({
  onFileChange,
  uploadedFileName,
  onDownloadTemplate,
}) => {
  return (
    <Grid item xs={12}>
      <Box mb={2}>
        <Typography variant="body1" gutterBottom>
          Sube un archivo Excel con los asientos contables que quieres importar.
          Cada fila representa una línea del asiento. Las filas con el mismo ID
          de asiento se agruparán automáticamente.
        </Typography>
        <Box component="ul" sx={{ mt: 1.5, mb: 1.5, pl: 3 }}>
          <Typography component="li" variant="body1" gutterBottom>
            Si un asiento tiene RUT, este debe pertenecer a una empresa creada.
          </Typography>
          <Typography component="li" variant="body1" gutterBottom>
            En la columna cuenta, debe ir el número de cuenta. Puedes buscarlo
            en el{' '}
            <Link
              component={RouterLink}
              to="/settings/accounting/nodes"
              color="primary"
              underline="hover"
            >
              plan de cuentas
            </Link>
            .
          </Typography>
        </Box>
        <Typography
          variant="body2"
          color="primary"
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
          onClick={onDownloadTemplate}
        >
          Descargar plantilla
        </Typography>
      </Box>
      <Uploader
        handleFileChange={onFileChange}
        buttonText="Subir Excel"
        accept=".xlsx,.xls"
        uploadedFileName={uploadedFileName}
      />
    </Grid>
  );
};

export default UploadSection;
